import type { WorkspaceProfileInfo } from '@affine/core/modules/workspace';
import { UNTITLED_WORKSPACE_NAME } from '@affine/env/constant';

/**
 * The single label rule for a workspace card: a resolved profile whose root doc carries no
 * `meta.name` (or a name the resolver could not reach) must NEVER render a blank label — fall
 * back to the same "Untitled" the avatar already uses. The real name arrives via the profile
 * revalidation (root-doc fetch); while that is in flight the caller shows a Skeleton instead.
 */
export function workspaceDisplayName(
  info: Pick<WorkspaceProfileInfo, 'name'> | null | undefined
): string {
  return info?.name || UNTITLED_WORKSPACE_NAME;
}
